import LogoutIcon from "@/assets/svgs/logout-icon";
import { useAuthActions } from "@convex-dev/auth/react";
import React, { Fragment, useState } from "react";
import { Text, View, Pressable } from "react-native";
import ConfirmLogoutModal from "../modals/confirm-logout-modal";

function ProfileLogoutItem() {
  const { signOut } = useAuthActions();
  const [isConfirmLogoutModalVisible, setIsConfirmLogoutModalVisible] =
    useState(false);

  const onPress = () => {
    setIsConfirmLogoutModalVisible(true);
  };

  return (
    <Fragment>
      <Pressable className="px-5 py-4" onPress={onPress}>
        <View className="flex-row items-center justify-between">
          <View className="flex-1">
            <Text className="font-geologica-regular font-normal text-xl text-teachLoop-textPrimary leading-[1.5]">
              Logout
            </Text>
          </View>
          <LogoutIcon
            pathClassName="stroke-teachLoop-textPrimary"
            className="size-6"
          />
        </View>
      </Pressable>
      <ConfirmLogoutModal
        isVisible={isConfirmLogoutModalVisible}
        onClose={() => setIsConfirmLogoutModalVisible(false)}
        onConfirm={() => {
          setIsConfirmLogoutModalVisible(false);
          signOut();
        }}
      />
    </Fragment>
  );
}

export default ProfileLogoutItem;
